module.exports = __webpack_public_path__ + "img/184.4ac5124f.svg";